import * as clearingApi from "../../api/clearingApi";
import { toast } from "react-toastify";

export function getYears() {
  const currentYear = new Date().getFullYear() - 1;
  const startYear = 1990;
  const years = [];

  for (let year = currentYear; year >= startYear; year--) {
    years.push(year);
  }

  return years;
}

export async function getClearing(clearingId) {
  try {
    return await clearingApi.getClearing(clearingId);
  } catch (error) {
    console.error("Error in get clearing:", error);
    return null;
  }
}

export async function getClearings(membership, year) {
  try {
    const clearings = await clearingApi.getClearings(membership, year);
    if (clearings) {
      clearings.sort((a, b) => a.toDate.localeCompare(b.toDate));
      return clearings;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error in get clearings:", error);
    return null;
  }
}

export async function getClearingsById(type, clearingId, companyId) {
  try {
    const clearings = await clearingApi.getClearingsbyId(type, clearingId, companyId);
    if (clearings) {
      clearings.sort((a, b) => b.damageYear - a.damageYear);
      return clearings;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error in get clearings by id:", error);
    return null;
  }
}

export async function getExcelFile(type, clearingId, companyId, download) {
  try {
    const excelfile = await clearingApi.getExcelFile(type, clearingId, companyId, download);
    if (!excelfile) {
      console.warn("No data");
      toast.error("Ingen data");
    }
  } catch (error) {
    console.error("Error in clearing get excel file:", error);
    return null;
  }
}